import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import outSideClick from 'directives/outSideClick';

import ProductReviews from 'assets/graphql/queries/ProductReviews.graphql';

import Rating from 'common/components/Rating';
import Review from 'components/Review';
import ReviewSortMenu from 'components/ReviewSortMenu';
@Component({
  apollo: {
    paginated_product_surveys: {
      query: ProductReviews,
      variables() {
        return {
          product_id: this.productId,
          product_type: this.productType,
          page_number: 1,
          sort_criteria: this.sortCriteria,
        };
      },
      fetchPolicy: 'network-only',
    },
  },
  props: {
    ratingValue: {
      type: Number,
    },
    surveyQuantity: {
      type: Number,
    },
    productId: {
      type: [String, Number],
      required: true,
    },
    productType: {
      type: String,
    },
    newBigbox: {
      type: Boolean,
      default: false,
    },
    inReviewsBar: {
      type: Boolean,
      default: false,
    },
    isTravel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Rating,
    Review,
    ReviewSortMenu,
  },
  directives: {
    clickOutside: outSideClick.directive,
  },
})
export default class BaseProductReviewComponent extends Vue {
  hasMoreSurveys = false;
  page_number = 1;
  showSortMenu = false;
  sortCriteria = 'last-reviews';

  changeSortCriteria(value) {
    this.sortCriteria = value;
  }

  closeSortMenu() {
    this.showSortMenu = false;
  }

  seeMore() {
    this.page_number += 1;
    this.$apollo.queries.paginated_product_surveys.fetchMore({
      variables: {
        page_number: this.page_number,
        sort_criteria: this.sortCriteria,
      },

      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) return previousResult;

        const newReviews = fetchMoreResult.paginated_product_surveys.results;
        const pageInfo = fetchMoreResult.paginated_product_surveys.page_info;

        this.hasMoreSurveys = pageInfo.has_next;

        return {
          paginated_product_surveys: {
            __typename: previousResult.paginated_product_surveys.__typename,
            results: [
              ...previousResult.paginated_product_surveys.results,
              ...newReviews,
            ],
            page_info: pageInfo,
          },
        };
      },
    });
  }

  toggleSortMenuDisplay() {
    this.showSortMenu = !this.showSortMenu;
  }

  get sortCriteriaDisplayText() {
    if (this.sortCriteria === 'last-reviews') {
      return 'Últimas opiniones';
    }
    return 'Más valoradas';
  }

  @Watch('$route')
  routeUpdated() {
    this.hasMoreSurveys = false;
    this.page_number = 1;
  }
}
